/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".inner_page_header[_ngcontent-%COMP%]{background-color:#333;background-image:url(/assets/images/terms.jpg);background-repeat:no-repeat;background-position:center center;position:relative}.accordian_main[_ngcontent-%COMP%]   .accordion-section-content[_ngcontent-%COMP%]{padding:15px;margin:1%;text-align:left;display:block;border:0 solid #fff;background-color:#fff}[_nghost-%COMP%] .btn.btn-link{font-size:24px;font-weight:400}.accordion-toggle[_ngcontent-%COMP%]{text-align:left}\n/*# sourceMappingURL=politica-de-privacidade.component.css.map*/"];
export { styles as styles };
